import React, { ReactElement } from 'react';
import { Progress as AntProgress } from 'antd';
import styled from 'styled-components';

interface ProgressCustomStyles {
  height?: number;
  trailColor?: string;
  barTransitionMs?: number;
}

interface ProgressProps {
  type?: 'line' | 'circle' | 'dashboard';
  percent: number;
  status?: 'active';
  showInfo?: boolean;
  size?: { width: number; height: number } | number;
  strokeColor?: string;
  customStyles?: ProgressCustomStyles;
}

function Progress({
  type,
  percent,
  status,
  showInfo,
  size,
  strokeColor,
  customStyles,
}: ProgressProps): ReactElement {
  const resolvedSize = customStyles?.height ? { width: -1, height: customStyles.height } : size;

  return (
    <StyledProgress
      type={type}
      size={resolvedSize}
      percent={percent}
      status={status}
      showInfo={showInfo}
      strokeColor={strokeColor}
      trailColor={customStyles?.trailColor}
      $barTransitionMs={customStyles?.barTransitionMs}
    />
  );
}

const StyledProgress = styled(AntProgress)<{ $barTransitionMs?: number }>`
  ${({ $barTransitionMs }) =>
    $barTransitionMs ? `.ant-progress-bg { transition: width ${$barTransitionMs}ms ease; }` : ''}
`;

export { Progress };
